module.exports = __webpack_public_path__ + "img/1550476598.3560f0cc.jpg";